import React, { useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'

import '../css/home.css'
import '../css/DJ/listDj.css'
// Services
import { listTwitchLinkService } from '../services/twitchLink.services';
import { listProductService } from '../services/product.services';
import TwitchLink from '../components/twitchLink/TwitchLink';
import ProductsLink from '../components/product/ProductsLink';
import ListVideo from '../components/videos/ListVideo';
import SocialMedia from '../components/socialMedia/SocialMedia';

// Services FIREBASE
import { collection, getDocs } from 'firebase/firestore'
import { collTwitchLinks, db } from '../firebase'

// Context
import { AuthContext } from "../context/auth.context";
import { useContext } from "react"
import ListTrack from '../components/track/ListTrack';
import ListDjs from './ListDjs';
import dj from "../images/dj-sombra.webp"

// IMAGES
import hearthisAt from "../images/HEARTHIS-AT.png"
import bandcamp from "../images/bandcamp.jpeg"
import CookieBanner from '../components/CookieBanner';




function Home() {
  const navigate = useNavigate()
  const { isAdmin } = useContext(AuthContext)
  // States
  const [isFetching, setIsFetching] = useState(true);
  const [listTwitchLink, setListTwitchLink] = useState(null)
  const [listProduct, setListProduct] = useState(null)

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      const docs = []
      const querySnapshot = await getDocs(collection(db, "products"));
      console.log("querySnapshot", querySnapshot)
      querySnapshot.forEach((doc) => {
        docs.push({ ...doc.data(), id: doc.id })
        setListProduct(docs)
      })
      const docsTL = []
      const responseTwitch = await getDocs(collTwitchLinks)
      responseTwitch.forEach((each) => {
        docsTL.push({ ...each.data(), id: each.id })
        setListTwitchLink(docsTL)
      })
      setIsFetching(false)

    } catch (error) {
      navigate("/error")
    }
  }


  if (isFetching === true) {
    return <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  }
  return (
    <div className='home-container'>
      <div className='twitch-link-container'>
        <TwitchLink listTwitchLink={listTwitchLink} />
      </div>
      {isAdmin &&

        <Link to={`/twitch-link/${listTwitchLink[0].id}/edit`}>
          <button>Editar TwitchLink</button>
        </Link>
      }

      <div>
        <SocialMedia />
      </div>

      {/* BANDCAMP Y HEALTHIS INICIO */}

     
<div class="sessions-container">

  
  <div class="session-block ">
    <div class="session-text">
      <h2>Todas nuestras sesiones disponibles en <a href={"https://hearthis.at/masqdance/"} target="_blank">Hearthis</a></h2>
    </div>
    <div class="session-image">
       <Link to={`https://hearthis.at/masqdance/` } target="_blank">
           <img src={hearthisAt} alt="" />
        </Link>
    </div>
  </div>

 
  <div class="session-block ">
    <div class="session-image">
      <Link to={`https://masqdancerecords.bandcamp.com/` } target="_blank">
           <img src={bandcamp} alt="" />
        </Link>
      
    </div>
    <div class="session-text">
      <h2>Y como no, encuentra nuestras producciones en <a href="https://masqdancerecords.bandcamp.com/" target="_blank">Bandcamp</a></h2>
    </div>
  </div>

</div>


      {/* BANDCAMP Y HEALTHIS. FIN */}

      <div className='products-linkd-div'>
        <ProductsLink listProduct={listProduct} />
      </div>

      <div>
        <ListVideo />
      </div>

      <div className="banner-container">
  <div className='banner-text'>
    <span>Escucha ya todas las canciones de nuestros artistas másQDance.</span>
  </div>
  <ListTrack />
</div>

      <Link to="/list-djs">
        <div className='dj-container'>
          <div className='list-dj-header'>
            <img src={dj} alt="" />
            <h3>Haz clik y conoce a nuestros Dj`S</h3>
          
          </div>
          

        </div>
      </Link>

    </div>
  )
}

export default Home